module.exports = __webpack_public_path__ + "img/iconfont.9cbc1fa6.svg";